var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlRoomForConcertsOutlined = function SvgHtlRoomForConcertsOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.654 13.9-2.047-1.657a.5.5 0 0 1-.185-.373v-.044a.5.5 0 0 1 .089-.285L6.58 5.664a3.254 3.254 0 0 1 1.644-3.253 3.263 3.263 0 1 1 1.956 6.092l-4.77 5.324a.5.5 0 0 1-.273.156.507.507 0 0 1-.483-.083Zm.288-1.053L8.926 8.4a3.263 3.263 0 0 1-1.957-1.544l-3.386 4.892 1.359 1.099Zm3.472-5.811c.398.317.892.488 1.4.487a2.25 2.25 0 0 0 1.631-.692l-.669-.24a5.02 5.02 0 0 1-2.478-1.956l-.39-.594a2.266 2.266 0 0 0 .506 3v-.005Zm.72-2.949a4.011 4.011 0 0 0 1.981 1.563l.855.308c.1-.31.132-.64.093-.964a2.247 2.247 0 0 0-.846-1.512 2.242 2.242 0 0 0-1.4-.486 2.26 2.26 0 0 0-1.183.33l.5.76Z"
  })));
};
export default SvgHtlRoomForConcertsOutlined;